// extracted by mini-css-extract-plugin
module.exports = {"root":"root-K4MVs","header":"header-1dEqC"};